import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import RateProvidedLabel from '../../../../../fulfillment-planner/rate-consumer/rate-provided-label';
import { CurrencyPropType } from '../../../../../prop-types/currency';
import { UserDateTimePropType } from '../../../../../prop-types/user-date-time';
import { DelegationDate, Delivery, Pickup, ShipDate, LabelCost } from '../../service-details-fields';
import messages from '../../service-details-fields/messages';
import ServiceDetailsWrapper from '../../service-details/service-details-wrapper';

const ServiceDetails = ({
  shipDate,
  pickupDateTime,
  delegationDateTime,
  deliveryDateTime,
  isPickupServiceSelected = false,
  hasProvidedRate = false,
  labelCost,
  isThirdPartyBilling = false,
}) => {
  return (
    <ServiceDetailsWrapper>
      {hasProvidedRate ? (
        <RateProvidedLabel />
      ) : (
        <>
          {delegationDateTime && <DelegationDate delegationDateTime={delegationDateTime} />}
          <ShipDate shipDate={shipDate} />
          {isPickupServiceSelected && <Pickup pickupDateTime={pickupDateTime} />}
          <Delivery deliveryDateTime={deliveryDateTime} label={<FormattedMessage {...messages.deliveryLabel} />} />
          <LabelCost isThirdPartyBilling={isThirdPartyBilling} labelCost={labelCost} />
        </>
      )}
    </ServiceDetailsWrapper>
  );
};

export default ServiceDetails;

ServiceDetails.propTypes = {
  shipDate: UserDateTimePropType,
  pickupDateTime: UserDateTimePropType,
  delegationDateTime: UserDateTimePropType,
  deliveryDateTime: UserDateTimePropType,
  isPickupServiceSelected: PropTypes.bool,
  hasProvidedRate: PropTypes.bool,
  labelCost: CurrencyPropType,
  isThirdPartyBilling: PropTypes.bool,
};
